import type { WorkspaceSpotlightTourStep } from '../../../shared/ui/common/WorkspaceSpotlightTour';
import {
  detail,
  spotlightStep,
  type QuickFillTourRefs,
} from './quickFillGuideHelpers';

export const buildAutoFillPreviewTourStep = (
  refs: QuickFillTourRefs
): WorkspaceSpotlightTourStep => spotlightStep(
  {
    id: 'auto-fill-preview',
    title: 'Preview Auto-fill before applying',
    focusLabel: 'Auto-fill preview',
    intro: 'The preview shows the changes Auto-fill proposes before they are applied to the table.',
    relatedTargets: [
      {
        label: 'Auto-fill controls',
        targetRef: refs.autoFillControlsRef,
      },
    ],
    details: [
      detail('Check first', [
        'Review the number of suggested matches and the detected pattern.',
        'Confirm that Auto-fill is filling only the intended empty cells.',
      ]),
      detail('Remember', [
        'Auto-fill is intended for clear, repeated value patterns, not rows that require individual judgment.',
        'Auto-fill changes Quick Fill values directly; it does not create exclusions or change the edit scope.',
        'Review the preview carefully before applying changes to avoid unintended bulk edits.',
      ], 'accent'),
    ],
    nextAction: 'Apply Auto-fill only when the preview matches the intended changes.',
  },
  refs.autoFillPreviewDialogRef,
  {
    top: 180,
    left: Math.max((window.innerWidth - 620) / 2, 24),
    width: Math.min(580, window.innerWidth - 48),
    height: 360,
  }
);

export const buildFooterActionsTourStep = (
  refs: QuickFillTourRefs
): WorkspaceSpotlightTourStep => spotlightStep(
  {
    id: 'footer-actions',
    title: 'Apply or continue from the footer',
    focusLabel: 'Apply and continue actions',
    showArrow: false,
    intro: 'Use the footer actions to save Quick Fill changes to Revit or continue to the next workflow.',
    details: [
      detail('How to use it', [
        'Use Apply when the reviewed changes are ready to be saved to Revit.',
        'Use Continue when you are ready to move to Validation.',
      ]),
      detail('Before you continue', [
        'Confirm that the save review shows the expected results.',
      ], 'accent'),
    ],
    nextAction: 'Use Apply only when the reviewed rows and values match the intended changes.',
  },
  refs.footerActionsRef,
  {
    top: Math.max(window.innerHeight - 96, 24),
    left: 24,
    width: Math.max(window.innerWidth - 48, 360),
    height: 72,
  }
);
